import './App.css'
import { Tooltip } from 'react-tooltip'
import Router from './config/routes/routes'
import { ErrorBoundary } from './component/errorBoundary/ErrorBoundary'
import { SnackbarProvider } from './component/Snackbar/SnackbarProvider'
import { APP_TOOLTIP_ID, APP_ERROR_TOOLTIP_ID } from './component/tooltip/tooltipIds'
import './component/tooltip/AppTooltip.css'

function App() {

  return (
    <>
      <div className='App'>
        <ErrorBoundary>
          <SnackbarProvider>
            <Router />
          </SnackbarProvider>
        </ErrorBoundary>
      </div>
      <Tooltip
        id={APP_TOOLTIP_ID}
        place="bottom"
        className="app-tooltip"
        classNameArrow="app-tooltip-arrow"
      />
      <Tooltip
        id={APP_ERROR_TOOLTIP_ID}
        place="top"
        className="app-tooltip app-tooltip--compact"
        classNameArrow="app-tooltip-arrow"
      />
    </>
  )
}

export default App
